/**
 * Estilo compartilhado dos campos de formulário do back-office.
 *
 * Padrão "clean": rótulo acima do campo (sem sobreposição), borda fina,
 * cantos suaves e realce rosa apenas no foco. Qualquer input solto escrito
 * direto no JSX deve usar estas mesmas classes para a tela ficar coerente.
 */

export const FIELD_LABEL_CLASS =
  "mb-1 block text-xs font-medium text-slate-600";

export const FIELD_BASE_CLASS =
  "block w-full rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 transition placeholder:text-slate-400 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400 read-only:bg-slate-50";

export const FIELD_BORDER_CLASS = "border-slate-200 focus:border-pink-500";

export const FIELD_BORDER_ERROR_CLASS =
  "border-rose-300 focus:border-rose-500";

export const FIELD_ERROR_TEXT_CLASS = "mt-1 block text-xs text-rose-500";

export const getFieldClass = (hasError, extraClass = "") =>
  [
    FIELD_BASE_CLASS,
    hasError ? FIELD_BORDER_ERROR_CLASS : FIELD_BORDER_CLASS,
    extraClass,
  ]
    .filter(Boolean)
    .join(" ");

/** Aceita tanto string quanto o objeto de erro do react-hook-form. */
export const getErrorMessage = (error) => {
  if (!error) return "";
  if (typeof error === "string") return error;

  return error.message || "";
};
